import React, { useState } from 'react';
import parser from "ua-parser-js";
import { feedback } from "@/services/http";
import "./index.scoped.css";

import { myFn, myConst } from "@/config/";
const { $$ } = myFn;

import BoxLoading from "@/components/BoxLoading";

export default function Faq() {
    const [type, setType] = useState('');
    const [text, setText] = useState('');
    const [contact, setContact] = useState('');
    const [loading, setLoading] = useState(false);

    function changeType(e) {
        setType(e.target.value.trim());
    }
    function changeText(e) {
        setText(e.target.value.trim());
    }
    function changeContact(e) {
        setContact(e.target.value.trim());
    }

    function check() {
        $$("#faq .type").removeClass("once");
        if (type === "") {
            window.mdui.snackbar({
                message: "请选择一个选项",
            });
        }
        if (text === "") {
            $$(".inputContent").trigger("input");
        }
        if (type === "" || text === "") {
            return;
        }
    }

    function submit() {
        check();
        if (loading) return;
        setLoading(true);
        const ua = new parser();
        const uaResult = ua.getResult();
        const send = {
            AppName: myConst.appName,
            type,
            text,
            contact,
            ua: navigator.userAgent,
            fingerprint: myConst.fingerprint,
            detail: uaResult,
        };
        feedback(send).then(d => {
            if (d.data.code == 200) {
                window.mdui.snackbar({ message: "发送成功" });
                setType("");
                setText("");
                setContact("");
            } else {
                window.mdui.snackbar({ message: "发送失败 " + d.data.msg });
            }
        }).catch(err => {
            window.mdui.snackbar({ message: `发送失败 网络错误 ${err.message}` });
        }).finally(() => {
            setLoading(false);
        });
    }


    return (
        <div id="faq">
            <div className="title mdui-typo">
                <h2>帮助及反馈</h2>
            </div>
            <div className="question">
                <div className="mdui-panel" mdui-panel="true">
                    <div className="mdui-panel-item mdui-panel-item-open">
                        <div className="mdui-panel-item-header">
                            <div className="mdui-panel-item-title">F.A.Q</div>
                            <i className="mdui-panel-item-arrow mdui-icon material-icons">keyboard_arrow_down</i>
                        </div>
                        <div className="mdui-divider"></div>
                        <div className="mdui-panel-item-body">
                            <div className="cont">
                                <h4 className="q">数据哪来的？</h4>
                                <p className="a">所有数据来自 <a href="http://www.zhuzhouparking.com" target="_blank" rel="noopener noreferrer">株洲停车</a> 官网
                            </p>
                            </div>
                        </div>
                        <div className="mdui-panel-item-body">
                            <div className="cont">
                                <h4 className="q">道路停车收费标准是什么？</h4>
                                <h4 className="q">如何缴停车费？</h4>
                                <h4 className="q">我市收费是在所有的地段吗</h4>
                                <h4 className="q">停车收费过程中有问题如何咨询或投诉？</h4>
                                <h4 className="q">停车票在哪领取？</h4>
                                <p className="a">访问 <a href="http://www.zhuzhouparking.com/Home/KnowledgeBase" target="_blank" rel="noopener noreferrer">株洲停车官网</a> 查看解答</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="feedback">
                <div className="mdui-panel" mdui-panel="true">
                    <div className="mdui-panel-item mdui-panel-item-open">
                        <div className="mdui-panel-item-header">
                            <div className="mdui-panel-item-title">反馈</div>
                            <i className="mdui-panel-item-arrow mdui-icon material-icons">keyboard_arrow_down</i>
                        </div>
                        <div className="mdui-divider"></div>
                        {loading ? <BoxLoading /> : null}

                        <div className={"mdui-panel-item-body type once " + (type == '' ? 'empty' : '')} >
                            <label className="mdui-radio">
                                <input type="radio" name="type" value="bug" onChange={e => { changeType(e); }} />
                                <i className="mdui-radio-icon"></i>
                                BUG
                        </label>
                            <label className="mdui-radio">
                                <input type="radio" name="type" value="complain" onChange={e => { changeType(e); }} />
                                <i className="mdui-radio-icon"></i>
                                吐槽
                        </label>
                            <label className="mdui-radio">
                                <input type="radio" name="type" value="suggest" onChange={e => { changeType(e); }} />
                                <i className="mdui-radio-icon"></i>
                                建议
                        </label>
                            <label className="mdui-radio">
                                <input type="radio" name="type" value="error" onChange={e => { changeType(e); }} />
                                <i className="mdui-radio-icon"></i>
                                信息错误
                        </label>
                        </div>
                        <div className="mdui-panel-item-body content">
                            <div className="mdui-textfield mdui-textfield-floating-label">
                                <label className="mdui-textfield-label">*想说点啥</label>
                                <textarea className="mdui-textfield-input inputContent" required onChange={e => { changeText(e); }}></textarea>
                                <div className="mdui-textfield-error">内容不能为空</div>
                            </div>
                            <div className="mdui-textfield mdui-textfield-floating-label">
                                <label className="mdui-textfield-label">联系方式</label>
                                <input className="mdui-textfield-input" onChange={e => { changeContact(e); }} />
                            </div>
                        </div>
                        <div className="mdui-panel-item-body send">
                            <button className="mdui-btn mdui-btn-raised mdui-btn-icon mdui-color-theme-accent mdui-ripple" onClick={submit}>
                                <i className="mdui-icon material-icons">send</i>
                            </button>
                        </div>
                    </div>
                </div>
            </div >
        </div >
    );
}
